import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import InfoItem from './InfoItem';
import { OrientationType } from '../constants';

function Orientation({ landscape }) {
  const { t } = useTranslation();
  return (
    <InfoItem
      icon={
        <div
          className={cn('device-info-content__orientation ', {
            'device-info-content__orientation--vertical': !landscape,
            'device-info-content__orientation--horizontal': landscape,
          })}
        />
      }
      text={
        landscape ? OrientationType(t).HORIZONTAL : OrientationType(t).VERTICAL
      }
    />
  );
}

export default Orientation;
